import { Reducer } from 'react'
import { User } from '@twilio/conversations'

import { MessageProps } from '../../../../types/chat'
import { ChatChannelBaseData } from './useChannelHelperTypes'

export interface ChannelReducer extends ChatChannelBaseData {
	channelDataIsLoading: boolean
}

export enum CHAT_CHANNEL_REDUCER_ACTIONS {
	INIT = 'INIT',
	SET_MESSAGES = 'SET_MESSAGES',
	SET_LAST_SEEN_INDEX = 'SET_LAST_SEEN_INDEX',
	SET_LAST_SEEN_PATIENT_INDEX = 'SET_LAST_SEEN_PATIENT_INDEX',
	SET_USERS_MODELS_FOR_PARTICIPANTS = 'SET_USERS_MODELS_FOR_PARTICIPANTS',
	SET_ONLINE_STATUS_FOR_PATIENT = 'SET_ONLINE_STATUS_FOR_PATIENT',
	SET_CHANNEL_DATA_LOADING_STATUS = 'SET_CHANNEL_DATA_LOADING_STATUS',
	SET_NEW_MESSAGE = 'SET_NEW_MESSAGE',
	RESET = 'RESET',
}

export interface ChatChannelSetMessagesAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_MESSAGES
	payload: MessageProps[]
}

export interface ChatChannelSetLastSeenIndexAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_LAST_SEEN_INDEX
	payload: number[]
}

export interface ChatChannelSetLastSeenPatientIndexAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_LAST_SEEN_PATIENT_INDEX
	payload: number
}

export interface ChatChannelSetUserModelsForParticipantsAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_USERS_MODELS_FOR_PARTICIPANTS
	payload: User[]
}

export interface ChatChannelSetOnlineStatusForPatientAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_ONLINE_STATUS_FOR_PATIENT
	payload: boolean
}

export interface ChatChannelInitAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.INIT
	payload: ChannelReducer
}

export interface ChatChannelSetChannelLoadingStatusAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_CHANNEL_DATA_LOADING_STATUS
	payload: boolean
}

export interface ChatChannelSetNewMessageAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.SET_NEW_MESSAGE
	payload: MessageProps
}

export interface ChatChannelResetAction {
	type: CHAT_CHANNEL_REDUCER_ACTIONS.RESET
}

export type ChatChannelReducerActions =
	| ChatChannelSetMessagesAction
	| ChatChannelSetLastSeenIndexAction
	| ChatChannelSetLastSeenPatientIndexAction
	| ChatChannelSetUserModelsForParticipantsAction
	| ChatChannelSetOnlineStatusForPatientAction
	| ChatChannelInitAction
	| ChatChannelSetChannelLoadingStatusAction
	| ChatChannelSetNewMessageAction
	| ChatChannelResetAction

export const useChannelHelperReducerInitialState: ChannelReducer = {
	channelMessages: [],
	lastSeenIndex: 0,
	lastSeenPatientIndex: -1,
	userModelsForParticipants: [],
	isPatientOnline: false,
	channelDataIsLoading: false,
}

export const useChannelHelperReducer: Reducer<
	ChannelReducer,
	ChatChannelReducerActions
> = (state, action) => {
	switch (action.type) {
		case CHAT_CHANNEL_REDUCER_ACTIONS.INIT: {
			return action.payload
		}
		case CHAT_CHANNEL_REDUCER_ACTIONS.SET_LAST_SEEN_INDEX: {
			return {
				...state,
				lastSeenIndex: action.payload[0],
				lastSeenPatientIndex: action.payload[1],
			}
		}
		case CHAT_CHANNEL_REDUCER_ACTIONS.SET_CHANNEL_DATA_LOADING_STATUS: {
			return {
				...state,
				channelDataIsLoading: action.payload,
			}
		}
		case CHAT_CHANNEL_REDUCER_ACTIONS.SET_NEW_MESSAGE: {
			return {
				...state,
				channelMessages: [...state.channelMessages, action.payload],
			}
		}
		case CHAT_CHANNEL_REDUCER_ACTIONS.RESET: {
			return useChannelHelperReducerInitialState
		}
		default: {
			return state
		}
	}
}
